import { Trophy, Medal } from 'lucide-react';
import { clsx } from 'clsx';

interface LeaderboardCardProps {
  rank: number;
  name: string;
  photoUrl?: string | null;
  points: number;
  subtitle?: string;
  isCurrentUser?: boolean;
}

export function LeaderboardCard({ rank, name, photoUrl, points, subtitle, isCurrentUser }: LeaderboardCardProps) {
  const getRankIcon = () => {
    if (rank === 1) return <Trophy size={20} className="text-brand-yellow" />;
    if (rank === 2) return <Medal size={20} className="text-gray-400" />;
    if (rank === 3) return <Medal size={20} className="text-amber-600" />;
    return <span className="text-sm font-bold text-gray-500 w-5 text-center">{rank}</span>;
  };

  return (
    <div
      className={clsx(
        'flex items-center gap-3 p-3 rounded-xl transition-all duration-200',
        isCurrentUser ? 'bg-brand-yellow/10 border border-brand-yellow' : 'bg-white hover:bg-gray-50',
        rank <= 3 && 'shadow-card'
      )}
    >
      <div className="flex-shrink-0 w-8 flex items-center justify-center">
        {getRankIcon()}
      </div>

      <div className="flex-shrink-0">
        {photoUrl ? (
          <img src={photoUrl} alt={name || ''} className="w-10 h-10 rounded-full object-cover" />
        ) : (
          <div className="w-10 h-10 rounded-full bg-brand-black flex items-center justify-center text-brand-yellow font-bold text-sm">
            {(name || '?').charAt(0).toUpperCase()}
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold truncate">{name || 'Conductor'}</p>
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
      </div>

      <div className="text-right">
        <p className="text-sm font-bold text-brand-black">{points.toLocaleString()}</p>
        <p className="text-xs text-gray-500">pts</p>
      </div>
    </div>
  );
}
